import React, { useState, useEffect } from "react";

function FormSupplierUpdate({ company }) {

  const [form, setForm] = useState({});

  console.log(company)
  // 🔥 Atualiza o form quando company chegar
  useEffect(() => {
    if (company) {
      setForm(company);
    }
  }, [company]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Dados atualizados:", form);
    alert("Perfil atualizado com sucesso!");
  };

  // 🔥 Evita erro se ainda não tiver dados
  if (!form || Object.keys(form).length === 0) {
    return <p className="text-center mt-10">Carregando dados...</p>;
  }

  console.log(company)

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">✏ Atualizar Perfil</h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          {Object.keys(form).map((campo) => (
            <div key={campo}>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {campo}
              </label>

              <input
                type="text"
                name={campo}
                value={form[campo] || ""}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              />
            </div>
          ))}

          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 w-full transition"
          >
            Guardar Alterações
          </button>
        </form>
      </div>
    </div>
  );
}

export default FormSupplierUpdate;